// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+tBks","text":"styles_text__3QhXX","icon":"styles_icon__aNuGz"};